<template>
  <div class="login-page container-fluid min-vh-100">
    <div class="row min-vh-100 align-items-stretch">

      <!-- COLUNA ESQUERDA -->
      <div class="col-12 col-lg-8 d-flex align-items-center justify-content-center">
        <div class="login-card w-100 mx-auto">
          
          <router-link to="/login" class="voltar mb-4 d-inline-flex align-items-center">
            ← Voltar
          </router-link>

          <!-- LOGO -->
          <div class="mb-4 d-flex align-items-center gap-2">
            <img src="../img/logotipo-icon.png" height="38" />
          </div>

          <!-- TÍTULO -->
          <div class="page-header mb-4">
            <p class="page-header-eyebrow">CADASTRO</p>
            <h1 class="page-title mb-1">Criar nova conta</h1>
          </div>
          <p class="page-subtitle mb-4">
            Já possui uma conta?
            <router-link to="/login">Acessar minha conta</router-link>
          </p>

            <!-- FORM -->
            <form @submit.prevent="criarUsuario">

          <!-- Informações pessoais -->
          <h5 class="titulo-sessao fw-bold mb-3">Informações pessoais</h5>

          <div class="mb-3">
            <label class="form-label">Nome *</label>
            <input type="text" class="form-control" v-model="nome" required />
          </div>

          <div class="mb-3">
            <label class="form-label">CPF *</label>
            <input type="text" class="form-control" v-model="cpf" required />
          </div>

          <div class="mb-3">
            <label class="form-label">Empresa</label>
            <input type="text" class="form-control" v-model="empresa" />
          </div>

          <!-- Informações de contato -->
          <h5 class="titulo-sessao fw-bold mb-3 mt-5">Informações de contato</h5>

          <!-- TELEFONE -->
          <label class="form-label">Telefone *</label>
          <div class="campo-senha mb-3">
            <img
                src="../img/tel-icon.png"
                class="icone cadeado"
                alt="E-mail"
            />
            <input type="text" class="form-control" v-model="telefone" required />
          </div>

          <!-- E-MAIL -->
          <label class="form-label">E-mail *</label>
          <div class="campo-senha mb-3">
            <img
                src="../img/email-icon.png"
                class="icone cadeado"
                alt="E-mail"
            />
            <input type="email" class="form-control" v-model="email" required />
          </div>

          <!-- Senha -->
          <h5 class="titulo-sessao fw-bold mb-3 mt-5">Informações de privacidade</h5>

          <div class="mb-3">
            <label class="form-label">Sua senha *</label>
            <div class="campo-senha">
              <img
                src="../img/block-blue-icon.png"
                class="icone cadeado"
                alt="Senha"
              />

              <input
                :type="mostrarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                v-model="senha"
                placeholder="Digite sua nova senha"
                required
              />

              <img src="../img/eye-icon.png" class="icone olho" alt="Mostrar senha"
                @click="mostrarSenha = !mostrarSenha" />
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label">Confirmar sua senha *</label>
            <div class="campo-senha">
              <img
                src="../img/block-blue-icon.png"
                class="icone cadeado"
                alt="Senha"
              />

              <input
                :type="mostrarConfirmarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                v-model="confirmarSenha"
                placeholder="Confirme sua nova senha"
                required
              />

              <img src="../img/eye-icon.png" class="icone olho" alt="Mostrar senha"
                @click="mostrarConfirmarSenha = !mostrarConfirmarSenha" />
            </div>
          </div>

          <button type="submit" class="btn btn-primary botao-azul w-100">
            Criar minha conta
          </button>

          <p class="texto-termos mt-3 mb-0 text-center">
            Você será direcionado ao Stripe para informar seu cartão.
            Os primeiros <strong>7 dias são grátis</strong> e a cobrança começa somente depois desse período.
          </p>

          <div class="ou-separador"><span>ou</span></div>

          <button type="button" class="btn btn-google w-100" @click="loginComGoogle">
            <span class="google-icon">G</span>
            Continuar com Google
          </button>

          <p class="texto-termos mt-3 text-center">
            Ao se cadastrar, você aceita nossos
            <router-link to="/terms" class="link-azul">
              Termos de Uso
            </router-link>
            e
            <router-link to="/privacy" class="link-azul">
              Política de Privacidade
            </router-link>.
          </p>

        </form>

        </div>
      </div>

      <!-- COLUNA DIREITA -->
        <div class="col-lg-4 d-none d-lg-flex login-banner p-0">
        <img
            src="../img/banner.svg"
            class="login-banner-img"
            alt="Banner"
        />
        </div>

    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <AlertModalSucesso
      :visible="alertModalSucesso.visible"
      :title="alertModalSucesso.title"
      :message="alertModalSucesso.message"
      type="success"
      @close="fecharAlertSucesso"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import AlertModalSucesso from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';

export default {
  name: "CriarConta",

  data() {
    return {
      nome: "",
      cpf: "",
      empresa: "",
      telefone: "",
      email: "",
      senha: "",
      confirmarSenha: "",
      mostrarSenha: false,
      mostrarConfirmarSenha: false,

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      // Modal sucesso
      alertModalSucesso: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      // Modal de loading
      loading: {
        visible: false,
      }
    };
  },

  components: {
    AlertModal,
    AlertModalSucesso,
    LoadingModal
  },

  methods: {

    loginComGoogle() {
      window.location.href = `${process.env.VUE_APP_BACKEND_URL}/auth/google`;
    },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirAlertSucesso(title, message) {
      this.alertModalSucesso = {
        visible: true,
        title,
        message,
        type: 'success'
      };
    },

    fecharAlertSucesso() {
      this.alertModalSucesso.visible = false;
      this.$router.push("/login");
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    async criarUsuario() {
      // Validação senha mínima
      if (this.senha.length < 8) {
        this.abrirAlert("Sistema", "A senha deve ter no mínimo 8 caracteres.", "error");
        return;
      }

      // Validação senha confirmada
      if (this.senha !== this.confirmarSenha) {
        this.abrirAlert("Sistema", "As senhas não coincidem.", "error");
        return;
      }

      const usuario = {
        nome: this.nome,
        cpf: this.cpf,
        empresa: this.empresa,
        telefone: this.telefone,
        email: this.email,
        password: this.senha
      };

      this.abrirLoading();

      try {
        const response = await fetch(`${process.env.VUE_APP_BACKEND_URL}/criar-checkout`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cadastro: usuario })
        });

        if (response.status === 422) {
          this.abrirAlert("Sistema", "Usuário já existe.", "error");
          return;
        }

        if (!response.ok) {
          const erro = await response.json();
          throw new Error(erro.message || "Erro ao criar usuário.");
        }

        const checkoutData = await response.json();

        if (!response.ok || !checkoutData.url) {
          throw new Error(checkoutData.erro || "Erro ao iniciar o pagamento.");
        }

        window.location.href = checkoutData.url;

      } catch (err) {
        console.error("Erro ao criar usuário:", err);
        this.abrirAlert("Sistema", "Erro ao criar usuário. Tente novamente mais tarde.", "error");
      } finally {
        this.fecharLoading();
      }
    }
  }
};
</script>


<style>

.campo-senha {
  position: relative;
}

.campo-senha .icone {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  opacity: 0.7;
  pointer-events: none;
}

.input-senha,
.campo-senha input {
  padding-left: 42px;
}

.campo-senha .icone.olho {
  left: auto;
  right: 12px;
  cursor: pointer;
  pointer-events: auto;
}

.login-page {
  background: #ffffff;
}

.login-page a {
  color: #0056ff;
  font-weight: 700;
}

.login-card {
  max-width: 520px !important;
  padding: 32px;
}

.login-card .page-header {
  margin-bottom: 8px;
}

.titulo-sessao {
  font-weight: 800;
}

.voltar {
  color: #0056ff;
  text-decoration: none;
  font-weight: 500;
}

.voltar:hover {
  text-decoration: underline;
}

.btn-login {
  background: #0056ff;
  border-radius: 8px;
  font-weight: 700;
  padding: 12px;
}

.btn-login:hover {
  background: #000;
}

.ou-separador {
  align-items: center;
  color: #6c757d;
  display: flex;
  gap: 12px;
  margin: 18px 0;
}

.ou-separador::before,
.ou-separador::after {
  background: #dee2e6;
  content: "";
  flex: 1;
  height: 1px;
}

.btn-google {
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  color: #212529;
  display: flex;
  font-weight: 600;
  gap: 10px;
  justify-content: center;
  padding: 12px;
}

.btn-google:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.google-icon {
  color: #4285f4;
  font-size: 18px;
  font-weight: 700;
}

/* BANNER DIREITO */
.login-banner {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

.login-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .login-card {
    max-width: 720px !important;
  }
}

@media (max-width: 575.98px) {
  .login-card {
    padding: 24px 20px;
  }
}


</style>